import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { ToastrService } from 'ngx-toastr';
import { ButtonLoading } from 'src/app/models/button-loading.model';
import { CompanyApplicationResponse, CompanyResponse, CompanyRoleResponse, NewCompanyRequest } from 'src/app/models/company.model';
import { InputAutocompleteModel } from 'src/app/models/input-autocomplete.model';
import { CompanyService } from 'src/app/services/company.service';
import { AuthenticationService } from '../../pages/authentication/authentication/authentication.service';
import { ResponseObject } from 'src/app/models/response-object.model';
import { HttpErrorResponse } from '@angular/common/http';
import { UserSaved } from 'src/app/models/user.model';

@Component({
  selector: 'app-modal-password-sat',
  templateUrl: './modal-password-sat.component.html',
  styleUrls: ['./modal-password-sat.component.scss']
})
export class ModalPasswordSatComponent implements OnInit {
  buttonSave: ButtonLoading = new ButtonLoading("btn-success", false, "GUARDAR", "fa-save");
  @Output() close = new EventEmitter<any>();
  @Input() edit: CompanyResponse = null;
  companies: any[] = [];
  allCompanies: any[] = [];
  inputs = new InputAutocompleteModel("", false, true, "", "fa-asterisk", "", "", null, []);
  timeout = null;
  selected = null;
  newPassword = "";
  confirmPassword = "";
  user: UserSaved = null;

  constructor(
    private toastService: ToastrService,
    private companyService: CompanyService,
    private authService: AuthenticationService
  ) {

  }

  ngOnInit(): void {
    this.user = JSON.parse(this.authService.getCurrentUser());
    // this.companies = Object.assign(this.companies, this.user.companyRoles);
    // this.allCompanies = this.companies;
    if (this.user.contadorGT) {
      this.getAssociatedCompanies();
    }else{
      this.getAllCompanies();
    }
  }
  
  getAssociatedCompanies() {
    this.companyService.getCompaniesAssociatedToPartner(this.user.id).subscribe({
      next: (response: ResponseObject) => {
        this.companies = response.data;
        this.allCompanies = this.companies;
      },
      error: (error: HttpErrorResponse) => {
        this.toastService.error("Error al obtener las companias asociadas");
      }
    })
  }

  getAllCompanies() {
    this.companyService.getAllCompanies().subscribe({
      next: (response: ResponseObject) => {
        this.companies = [...response.data];
        this.allCompanies = [...response.data];
      },
      error: (error: HttpErrorResponse) => {
        this.toastService.error("Error al obtener las companias asociadas");
      }
    })
  }

  searchCompany() {
    clearTimeout(this.timeout);
    this.inputs.class = "typing";

    this.timeout = setTimeout(() => {

      const val = (this.inputs.value || "").toString().toLowerCase().trim();

      this.companies = this.allCompanies.filter((company) => {

        const alphanumericId = (company.alphanumericId || "").toString().toLowerCase();
        const companyName = (company.companyName || company.name || "").toLowerCase();
        const companyNIT = (company.companyNIT || company.nit || "").toString().toLowerCase();
        const companyId = (company.companyId || company.id || "").toString();

        return alphanumericId.includes(val)
          || companyName.includes(val)
          || companyNIT.includes(val)
          || companyId.includes(val);

      });

      this.inputs.verified = false;

      if (this.companies.length > 0) {
        this.inputs.class = "fa-list";
      } else {
        this.inputs.class = "fa-xmark";
      }

    }, 300);
  }

  selectCompany(selected) {
    var alphanumeric = selected.alphanumericId;
    var companyNit = selected?.companyNIT || selected?.nit;
    var nameCompany = selected?.companyName || selected?.name;
    this.inputs.value = alphanumeric + " - " + companyNit + " - " + nameCompany;
    this.inputs.verified = true;
    this.inputs.class = "fa-circle-check";
    this.selected = selected;
  }

  savePassword() {
    if (this.buttonSave.loading) {
      return;
    }
    this.buttonSave.loading = true;
    var request = new NewCompanyRequest();
    var idselected = this.selected?.companyId || this.selected?.id;
    request.companyPass = (!this.edit)? idselected: this.edit.id;
    request.pass = this.newPassword;
    this.companyService.savePasswordSat(request, this.user.contadorGT).subscribe({
      next: (response: ResponseObject) => {
        this.toastService.success("Contraseña guardada correctamente!");
        this.close.emit(null);
      },
      error: (error: HttpErrorResponse) => {
        this.toastService.error(error.error.message);
      }
    })
  }

}
